module.exports = __webpack_public_path__ + "img/8-1.3437afb8.png";